// ABOUTME: Pivot table row selector dropdown for report hub.
// ABOUTME: Uses ShValidatedInputDropdown to show validation errors when no row is selected.
import { useTranslation } from "react-i18next";
import ShValidatedInputDropdown from "../../../../theme/dropdowns/ShValidatedInputDropdown";



export const RhPivotTableRow = (props) => {
    const { t } = useTranslation();
    return (
        <ShValidatedInputDropdown
            name="pivotTableRow"
            onChange={(name, selected) => {
                if(selected === null || selected === -1) {
                    props.setCurrentReport(prev => ({
                        ...prev,
                        table: {
                            ...prev.table,
                            row:null,
                            column: {
                                ...prev.table.column,
                                key:null,
                                values:[]
                            }
                        }
                    }));
                    return;
                }
                const selectedOption = props.chartOption?.pivotTableOptions[selected];
                props.setCurrentReport(prev => ({
                    ...prev,
                    table: {
                        ...prev.table,
                        row:selectedOption,
                        column: {
                            ...prev.table.column,
                            key:null,
                            values:[]
                        }
                    }
                }))
            }}
            noSelection={t("select_row")}
            options={props.chartOption?.pivotTableOptions ?? []}
            selected={props.chartOption?.pivotTableOptions?.findIndex(filter => filter === props.currentReport.table.row) ?? -1}
            closeOnSelection
            stopPropagation
            useTranslation
            height={40}
            error={props.error}
            selectIndex
        />
    )
}
